import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmPasswordValidator } from "./confirm-password.validator";
import { UserService } from "app/services/user.service";
import { SessionService } from "app/services/session.service";
import { AuthTokenService } from "app/services/auth-token.service";
import { QueryModel } from "app/models/queryModel";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { CookieService } from "ngx-cookie-service";
@Component({
  selector: "app-users-change-password",
  templateUrl: "./users-change-password.component.html",
  styleUrls: ["./users-change-password.component.css"],
})
export class UsersChangePasswordComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private sessionService: SessionService,
    private AuthTokenService: AuthTokenService,
    private cookieService: CookieService
  ) { }

  ngOnInit(): void {
    this.registerForm = this.fb.group(
      {
        password: ["", Validators.required],
        confirmPassword: ["", Validators.required],
      },
      {
        validator: ConfirmPasswordValidator("password", "confirmPassword"),
      }
    );
  }

  registerForm: FormGroup;
  submitted: boolean = false;
  customerInfo: any;
  queryModelSetScope: QueryModel = new QueryModel();

  onSubmit() {
    this.submitted = true;
  }

  updatePasswordForm() {
    let userData = JSON.parse(this.cookieService.get("UserData"));
    // console.log("UserData:", userData.authorise_link);

    this.queryModelSetScope.request.query = "proc_update_user";
    this.queryModelSetScope.request.parameters = [];
    this.queryModelSetScope.request.parameters.push(userData.authorise_link);
    this.queryModelSetScope.request.parameters.push(
      this.registerForm.value.confirmPassword
    );
    this.queryModelSetScope.request.skip = true;
    this.queryModelSetScope.authorise_token = userData.authorise_token;
    this.queryModelSetScope.authorise_link = userData.authorise_link;
    this.userService.GetMethod(this.queryModelSetScope).subscribe((res) => {
      // console.log("Response of Password Change Proc:", res);
      if (res.body.message) {
        let template = `
        <div style='text-align:center'>
        <div style='margin-bottom: 10px; margin-top: 5px'>
            <b>${res.body.message}</b>
        </div>
        <div style="text-align:left; margin-left: 30px">
        `;
        var base64regex =
          /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
        for (let i = 0; i < res.body.criteria.length; i++) {
          if (base64regex.test(res.body.criteria[i]) == true) {
            // console.log("Yes it is base64");
            template =
              template + `<b>${i + 1}. </b>${atob(res.body.criteria[i])} <br>`;
            i = i + 1;
          }
          template =
            template + `<b>${i + 1}. </b> ${res.body.criteria[i]} <br>`;
        }
        template = template + `</div></div>`;

        // console.log("Template after completion:", template);

        Swal.fire({
          html: `${template}`,
        });
      } else if (res.body.data[0].message) {
        Swal.fire({
          icon: "success",
          title: res.body.data[0].message,
        });
      }
    });
  }

  closeModal() {
    this.registerForm.reset();
    this.registerForm.markAsPristine();
    this.registerForm.markAsUntouched();
    this.registerForm.clearAsyncValidators();
  }
}
